import React, { useEffect, useState } from "react";
import { TreeSelect } from "antd";
import { useSelector } from "react-redux";


 
const SteamTreeSelectCustomWithSelectAll = ({
  label,  
  data, 
  idKey, 
  nameKey,
  valueKey,
  selectedValues, 
  onSelect,
  setSelectedValues,
  isMultipleSelect=true,
  isSelectAll=true,
}) => {
  const [internalSelectedValues, setInternalSelectedValues] = useState(selectedValues);
  const [isChecked, setIsChecked] = useState(false);

  const treeData = data?.map((item) => ({
    key: item[idKey]?.toString(),
    title: item[nameKey], 
    value: item[valueKey],
  }));

  // Update the selected values when selectedValues prop changes
  useEffect(() => {
    setInternalSelectedValues(selectedValues);
  }, [data,selectedValues]);

  useEffect(() =>{
    setIsChecked(false)
  },[data])
  
  const modeselect = useSelector((state) => state.darkMode);

  const { isdarkMode } = modeselect;

  return (
    <div className="flex flex-col ">
        <div className="flex items-center">
            {label && <label className="pr-3 w-32 text-left">{label || ''}</label>}
            <TreeSelect
            showSearch
                allowClear={true}
                
                placeholder={`Select ${label || ''}`}
                treeCheckable={isMultipleSelect}
                showCheckedStrategy={TreeSelect.SHOW_CHILD}
                className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
                dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}

                dropdownStyle={{ maxHeight: "300px",  }}
                onChange={(values) => {
                  setInternalSelectedValues(values);
                  onSelect(values);
                }}
                value={internalSelectedValues}
                maxTagCount={2}
                maxTagPlaceholder={omittedValues =>
                `+ ${omittedValues.length} Blocks ...`
                }
                filterTreeNode={(input, node) =>
    String(node.title)?.toLowerCase().includes(input.toLowerCase())
  }
                treeData={[
  isSelectAll && {
    title:
      internalSelectedValues?.length === treeData?.length ? (
        <span
          onClick={() => { 
            setInternalSelectedValues([]);
            setSelectedValues([]);
          }}
          style={{
            display: "inline-block",
            color: "#286FBE",
            cursor: "pointer"
          }}
        >
          Unselect all
        </span>
      ) : (
        <span
          onClick={() => {
            const values = treeData.map(item => item.value);
            setInternalSelectedValues(values);
            onSelect(values);
          }}
          style={{
            display: "inline-block",
            color: "#286FBE",
            cursor: "pointer"
          }}
        >
          Select all
        </span>
      ),
    value: "__selectAll__", // unique value
    disableCheckbox: true,
    disabled: true,
    selectable: false, // ensures search & selection ignore this node
  },
  ...treeData
].filter(Boolean)}
                
            />
        </div>
    </div>
);
};

export default SteamTreeSelectCustomWithSelectAll;
